"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var dataSchema_service_1 = require("../_services/dataSchema.service");
var SchemaPkResolver = /** @class */ (function () {
    function SchemaPkResolver(http, dataSchemaService) {
        this.http = http;
        this.dataSchemaService = dataSchemaService;
    }
    SchemaPkResolver.prototype.resolve = function (activatedRouteSnapshot) {
        var daeID = activatedRouteSnapshot.params["id"];
        return this.dataSchemaService.getSchemaPkList(daeID);
    };
    return SchemaPkResolver;
}());
exports.SchemaPkResolver = SchemaPkResolver;
